import React from 'react';
import { Helmet } from 'react-helmet';
import Footer from '../../Shared/Footer/Footer';
import Navbar from '../../Shared/Navbar/Navbar';
import AboutDetails from '../AboutDetails/AboutDetails';

const About = () => {
    return (
        <div>
            <Helmet>
                <title>About | Biotech</title>
            </Helmet>
            <Navbar />
            <AboutDetails />
            <Footer />
        </div>
    );
};

export default About;